import axios from 'axios';

const isLocalHost =
  typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

const API_BASE_URL ='https://dylora-30mprstq8-dyloras-projects.vercel.app/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Enrollment API
export const enrollmentAPI = {
  saveEnrollment: async (enrollmentData) => {
    const response = await api.post('/enrollments', enrollmentData);
    return response.data;
  },

  getAllEnrollments: async (password = 'VikramDyD@0720') => {
    // Add password as query parameter for simple auth
    const response = await api.get(`/enrollments?password=${password}`);
    return response.data;
  },

  getEnrollmentById: async (id) => {
    const response = await api.get(`/enrollments/${id}`);
    return response.data;
  },

  updateEnrollment: async (id, updateData) => {
    const response = await api.put(`/enrollments/${id}`, updateData);
    return response.data;
  },

  deleteEnrollment: async (id) => {
    const response = await api.delete(`/enrollments/${id}`);
    return response.data;
  },
};

// Admin API
export const adminAPI = {
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    return response.data;
  },

  verifyToken: async (token) => {
    const response = await api.post('/admin/verify', { token });
    return response.data;
  },

  getStats: async (password = 'VikramDyD@0720') => {
    const response = await api.get(`/admin/stats?password=${password}`);
    return response.data;
  },
};

// Certificate API
export const certificateAPI = {
  getAllCertificates: async (password = 'VikramDyD@0720') => {
    const response = await api.get(`/certificates?password=${encodeURIComponent(password)}`);
    return response.data;
  },

  createCertificate: async (certificateData, password = 'VikramDyD@0720') => {
    const response = await api.post('/certificates', {
      ...certificateData,
      password
    });
    return response.data;
  },

  updateCertificate: async (id, updateData, password = 'VikramDyD@0720') => {
    const response = await api.put(`/certificates/${id}`, {
      ...updateData,
      password
    });
    return response.data;
  },

  deleteCertificate: async (id, password = 'VikramDyD@0720') => {
    const response = await api.delete(`/certificates/${id}?password=${encodeURIComponent(password)}`);
    return response.data;
  },

  verifyCertificate: async (verificationCode) => {
    const response = await api.get(`/certificates/verify/${verificationCode}`);
    return response.data;
  }
};

// Export API instance
export default {
  ...enrollmentAPI,
  ...adminAPI,
  ...certificateAPI,
  
  // Helper method for handling errors
  handleError: (error) => {
    if (error.response) {
      // Server responded with error
      throw new Error(error.response.data.message || 'Server error occurred');
    } else if (error.request) {
      // Request made but no response
      throw new Error('No response from server. Please check your connection.');
    } else {
      // Something else happened
      throw new Error(error.message || 'An error occurred');
    }
  },

  // Add auth token to requests
  setAuthToken: (token) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  },
};
